<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    title=""
    :show-confirm-button="false"
  >
    <div class="dialog-content">
      <div
        class="card-tips-warning"
        v-if="showPopUpPrompt"
      >
        <img
          src="@/assets/img/icon_warning.png"
          alt=""
        >
        <span class="tips-txt">
          {{ pingAnServiceFinishedPageConfig ? pingAnServiceFinishedPageConfig.popUpPrompt || '请上传客户5星好评和10分照片' : '请上传客户5星好评和10分照片' }}
        </span>
      </div>
      <div
        class="img-box"
        v-if="showPopUpImage"
      >
        <img
          :src="pingAnServiceFinishedPageConfig.popUpImageUrl"
          alt=""
          class="img-container"
          v-if="pingAnServiceFinishedPageConfig && pingAnServiceFinishedPageConfig.popUpImageUrl"
        >
        <img
          src="@/assets/img/orderGeneral/defaultPopUpImageUrl.jpg"
          alt=""
          class="img-bg"
          v-else
        >
      </div>
      <div class="btn-box">
        <van-uploader
          accept="image/*"
          :after-read="afterRead"
        >
          <div class="btn btn-primary">点击拍照上传</div>
        </van-uploader>
        <div
          class="btn"
          @click="close"
        >稍后上传</div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'UploadDialog',
  props: {
    pingAnServiceFinishedPageConfig: {
      type: Object,
      default: null
    },
    taskDetail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    showPopUpImage() {
      if (this.taskDetail && this.taskDetail.isPaicOrder === 1) {
        return true;
      }
      return this.pingAnServiceFinishedPageConfig && this.pingAnServiceFinishedPageConfig.popUpImageUrl;
    },
    showPopUpPrompt() {
      if (this.taskDetail && this.taskDetail.isPaicOrder === 1) {
        return '请上传客户5星好评和10分照片';
      }
      return this.pingAnServiceFinishedPageConfig && this.pingAnServiceFinishedPageConfig.popUpPrompt;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async afterRead() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog{
  &.van-dialog ::v-deep {
    .van-dialog__header{
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content{
      .dialog-content{
        padding: 16px;
        .card-tips-warning{
          display: flex;
          align-items: center;
          justify-content: center;

          text-align: center;

          img{
            width: 24px;
            height: 24px;
          }

          .tips-txt{
            margin-left: 5px;

            letter-spacing: -0.56px;

            color: #F32222;

            font-family: PingFangSC-Medium;
            font-size: 16px;
            font-weight: 500;
          }
        }

        .img-box {
          display: flex;
          overflow: hidden;
          align-items: center;
          justify-content: center;

          width: 100%;
          height: 170px;
          margin: 24px 0;

          border-radius: 4px;
          background: #EBEFF2;

          .img-container {
            height: 100%;
          }

          .img-bg {
            width: 100%;
          }
        }
      }
      .btn-box{
        .van-uploader{
          width: 100%;
          .van-uploader__wrapper{
            width: 100%;
            .van-uploader__input-wrapper{
              width: 100%;
            }
          }
        }
        .btn{
          height: 48px;
          margin: 0;
          margin-top: 12px;
          padding: 0 12px;

          text-align: center;

          color: #ccc;
          border-radius: 8px;

          font-size: 16px;
          line-height: 48px;

          &.btn-primary{
            color: #FFFFFF;
            background: rgb(24, 144, 255);
          }
        }
      }
    }
    .van-dialog__footer{
      padding: 0;
    }
  }
}
</style>
